import { combineReducers } from 'redux';
import { createReducer, createRequestReducer, createSingleItemReducer } from 'utils';

import {
  GET_BIKE,
  GET_BIKE_PRICES,
  CLEAR_BIKE,
  GET_ORDER,
  GET_TRANSACTION,
  DATA_ORDER_SET_COUNT,
  DATA_ORDER_INIT_ORDER,
  DATA_ORDER_UPDATE_DETAILS,
  DATA_ORDER_UPDATE_DETAILS_VALIDATION
} from '../constants';

const itemReducer = createSingleItemReducer({

  // somewhy we use item name as 'data' as default
  item: 'item'
});

const bike = createReducer(itemReducer.initialState, {
  [GET_BIKE]: (state, action) => createRequestReducer(state, action, {
    SEND: (state) => ({
      ...state,
      isFetching: true,
      error: null
    }),

    SUCCESS: (state, action) => {
      const nextState = {
        ...state,
        isFetching: false,
        error: null
      };

      if (nextState.item) {
        nextState.item = {
          ...action.response,
          price: nextState.item.price,
          salesPrice: nextState.item.salesPrice
        };
      } else {
        nextState.item = action.response;
      }

      return nextState;
    },

    FAIL: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.error
    })
  }),

  [GET_BIKE_PRICES]: (state, action) => createRequestReducer(state, action, {
    SEND: (state) => ({
      ...state,
      isFetching: true,
      error: null
    }),

    SUCCESS: (state, action) => ({
      ...state,
      item: action.response,
      isFetching: false,
      error: null
    }),

    FAIL: (state, action) => {
      const nextState = {
        ...state,
        isFetching: false,
        error: action.error
      };

      // bike unavailable, reset pricing
      if (nextState.item) {
        nextState.item = {
          ...nextState.item,
          price: null,
          salesPrice: null
        };
      } else {
        nextState.item = null;
      }

      return nextState;
    }
  }),

  [CLEAR_BIKE]: () => itemReducer.initialState
});

const order = createReducer(itemReducer.initialState, {
  [GET_ORDER]: itemReducer
});

const transaction = createReducer(itemReducer.initialState, {
  [GET_TRANSACTION]: itemReducer
});

const createInitialDetailsState = () => ({
  count: 1,
  extras: [],
  details: {
    order: {
      name: '',
      email: '',
      emailConfirm: '',
      phone: '',
      comment: ''
    },
    validation: {}
  }
});

export const details = createReducer(createInitialDetailsState(), {
  [DATA_ORDER_SET_COUNT]: (state, { payload }) => ({
    ...state,
    count: Math.max(payload.count, 1)
  }),
  [DATA_ORDER_INIT_ORDER]: (state, { payload }) => ({
    ...state,
    ...payload
  }),
  [DATA_ORDER_UPDATE_DETAILS]: (state, { payload }) => ({
    ...state,
    details: {
      ...state.details,
      order: {
        ...state.details.order,
        ...payload.data
      }
    }
  }),
  [DATA_ORDER_UPDATE_DETAILS_VALIDATION]: (state, { payload }) => ({
    ...state,
    details: {
      ...state.details,
      validation: {
        ...payload.errors
      }
    }
  })
});

export default combineReducers({
  bike,
  order,
  transaction,
  details
});



// WEBPACK FOOTER //
// ./src/reducers/order.js